import {Scout} from "@/modules/scouting/entity";
import {injectable} from "inversify";
import {AbstractStaffMemberFactory} from "@/modules/staff/services/factories/AbstractStaffMemberFactory";
import {StaffMember} from "@/modules/staff/entity";

@injectable()
export class ScoutFactory extends AbstractStaffMemberFactory {
  protected make(): StaffMember {
    return new Scout();
  }
}